import React from 'react';
import type { LearningTraining } from '../types';

const TrainingCardMedia: React.FC<{ training: LearningTraining }> = ({ training }) => {
  if (training.thumbnail?.url) return <img src={training.thumbnail.url} alt="" />;
  if (training.video?.url) {
    // Do not mount the video itself as a card preview. A certification can have
    // many lessons, and mobile browsers otherwise issue a range request for
    // every video before the learner has chosen one.
    return <span className="reusable-training-card__placeholder reusable-training-card__placeholder--video" aria-hidden="true">▶</span>;
  }
  return <span className="reusable-training-card__placeholder" aria-hidden="true" />;
};

export default TrainingCardMedia;
